import { combineReducers } from "redux";

import loginReducer from "../../modules/LoginPage/loginSlice";
import { config } from "./config";
import { workflow, workflowChildren, expandedWorkflows } from "./workflow_list";
import { workflowCreate } from "./workflow_create";

import { languageSelector } from "./internationalize";
import { showFilterMenu } from "./navbar";
import { userWorkflowModal } from "./user_workflow";
import { workflowSearch } from "./workflowSearch";
import { permissions } from "../../modules/common/permissions/reducer";

// New module pattern
import { workflowList } from "../../modules/dashboard";
import { showLeftSidebar } from "./sidebar";

//THIS IS THE STRUCTURE/STATE OF YOUR STORE//
export const rootReducer = combineReducers({
  authentication: loginReducer,
  config,
  expandedWorkflows,
  showFilterMenu,
  showLeftSidebar,
  workflow,
  workflowChildren,
  workflowCreate,
  languageSelector,
  userWorkflowModal,
  workflowSearch,
  permissions,

  // New module pattern
  workflowList
});
